import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import Footer from "components/ui/Footer";
import Icon from "../../components/AppIcon";
import TvWindow from "./components/TvWindow";
import LiveTvStatus from "./components/LiveTvStatus";
import LiveTv from "./components/LiveTv";

const Live = () => {
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <>
      <Helmet>
        <title>Live - DeveloperNoob</title>
        <meta name="description" content="Watch Live Tv - DeveloperNoob" />
        <meta
          name="keywords"
          content="live,watch live, hire developer, backend developer, frontend learning"
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Page Header */}
        <Header />

        <main className="pt-20 pb-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center space-x-3 mb-4">
                <Icon name="Terminal" size={32} className="text-primary" />
                <h1 className="text-3xl md:text-4xl font-bold text-foreground font-inter">
                  Watch Live
                </h1>
              </div>
              <p className="text-lg text-muted-foreground font-source max-w-2xl mx-auto">
                Welcome to the DeveloperNoob{" "}
                <span className="text-primary">Live TV:</span>
                No subscriptions, no buffering (hopefully). Sit back and enjoy
                the show—because here, even the bugs get airtime. 🎬📺
              </p>
            </div>

            {/* Main Content Area */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <TvWindow
                  isMinimized={isMinimized}
                  onMinimize={() => setIsMinimized(!isMinimized)}
                  onMaximize={() => setIsMinimized(false)}
                  title="Watch TV"
                >
                  <div className=" flex flex-col min-h-[460px] space-y-4 justify-between">
                    <LiveTv />
                  </div>
                </TvWindow>
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-1">
                {/* Sidebar goes here */}
                <LiveTvStatus />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Live;
